/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { resetPassword } from '../../api/firebaseUtils';

const boxStyle = {
  maxWidth: '360px',
  minHeight: '200px',
  backgroundColor: 'white',
  margin: '0 auto',
  boxShadow:
    '0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 20%), 0 1px 5px 0 rgb(0 0 0 / 12%)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  position: 'relative',
};

const topicStyle = {
  padding: '24px',
  fontWeight: 500,
  fontSize: '20px',
};

const paragraphStyle = {
  padding: '0 24px',
};

const textFieldStyle = {
  paddingLeft: '24px',
  maxWidth: '312px',
};

const buttonRowStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  margin: '24px',
};

const buttonStyle = {
  minWidth: '140px',
  alignSelf: 'center',
};

const InvitePage = ({ t }) => {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [errorText, setErrorText] = useState(undefined);
  const [successText, setSuccessText] = useState(undefined);
  const [enterPressed, setEnterPressed] = useState(false);

  useEffect(() => {
    const prefillEmail = searchParams.get('email');
    if (prefillEmail) {
      setEmail(prefillEmail);
    }
  }, [searchParams]);

  const sendReset = () => {
    resetPassword(email)
      .then(() => {
        setErrorText(undefined);
        setSuccessText(
          `${t('invite.successPart1')} ${email} ${t('invite.successPart2')}`
        );
      })
      .catch(error => {
        if (error.code === 'auth/user-not-found') {
          setErrorText(t('invite.userNotFound'));
        } else {
          setErrorText(t('invite.sendFailed'));
        }
      });
  };

  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === 'Enter' && !enterPressed) {
        setEnterPressed(true);
        event.preventDefault();
        if (!successText && email.length > 0) {
          sendReset();
        }
      }
    };
    const keyUpHandler = event => {
      if (event.key === 'Enter') {
        setEnterPressed(false);
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    document.addEventListener('keyup', keyUpHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
      document.removeEventListener('keyup', keyUpHandler);
    };
  }, [email, enterPressed, successText]);

  if (successText) {
    return (
      <div style={boxStyle}>
        <div style={topicStyle}>{t('invite.title')}</div>
        <p style={paragraphStyle}>{successText}</p>
        <div style={buttonRowStyle}>
          <Button
            component={Link}
            to="/"
            variant="contained"
            color="primary"
            style={buttonStyle}
          >
            {t('invite.backToLogin')}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div style={boxStyle}>
      <div style={topicStyle}>{t('invite.title')}</div>
      <p style={paragraphStyle}>{t('invite.instructions')}</p>
      {errorText ? (
        <p style={{ ...paragraphStyle, color: 'red' }}>{errorText}</p>
      ) : (
        ''
      )}
      <TextField
        style={textFieldStyle}
        type="text"
        label={t('invite.email')}
        value={email}
        name="email"
        margin="normal"
        onChange={event => setEmail(event.target.value)}
        fullWidth
      />
      <div style={buttonRowStyle}>
        <Button
          component={Link}
          to="/"
          variant="contained"
          color="secondary"
          style={buttonStyle}
        >
          {t('invite.backToLogin')}
        </Button>
        <Button
          component="span"
          variant="contained"
          color="primary"
          style={buttonStyle}
          onClick={sendReset}
        >
          {t('invite.sendPasswordReset')}
        </Button>
      </div>
    </div>
  );
};

export default withTranslation('translations')(InvitePage);
